module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addTag
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-663a78f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagButton.vue
// module id = 20
// module chunks = 0